import React from 'react';
import { cn } from '../../lib/utils';

type HomeButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'accent';
type HomeButtonSize = 'sm' | 'md' | 'lg';

const VARIANTS: Record<HomeButtonVariant, string> = {
  primary:
    'bg-[var(--ir-mint)] text-[var(--ir-deep)] hover:bg-[#55dc78] border border-[var(--ir-mint)]',
  accent:
    'bg-[var(--ir-mint)] text-[var(--ir-deep)] hover:bg-[#55dc78] border border-[var(--ir-mint)] shadow-[0_16px_34px_-22px_rgba(0,31,34,0.28)]',
  secondary:
    'bg-white text-[var(--ir-ink)] hover:bg-[var(--ir-ivory)] border border-[var(--ir-line)]',
  outline:
    'bg-white/80 border border-[var(--ir-line)] text-[var(--ir-ink)] hover:bg-white',
  ghost:
    'bg-transparent text-[var(--ir-ink)] hover:bg-[var(--ir-mist)] border border-transparent',
};

const SIZES: Record<HomeButtonSize, string> = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-base',
  lg: 'px-8 py-4 text-lg font-medium',
};

export function homeButtonClasses(
  variant: HomeButtonVariant = 'accent',
  size: HomeButtonSize = 'md'
): string {
  return cn(
    'rounded-full transition-all duration-200 inline-flex items-center justify-center gap-2 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[var(--ir-terra)]',
    VARIANTS[variant],
    SIZES[size]
  );
}

export function HomeButton({
  variant = 'accent',
  size = 'md',
  className,
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: HomeButtonVariant;
  size?: HomeButtonSize;
}): React.JSX.Element {
  return (
    <button
      className={cn(homeButtonClasses(variant, size), className)}
      {...props}
    >
      {children}
    </button>
  );
}
